<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { ChipTone } from './chip-tone';

  interface Properties {
    /** Optional tone; defaults to muted. */
    tone?: ChipTone;
    /** Text content rendered inside the chip. */
    children: Snippet;
  }

  const { tone = 'default', children }: Properties = $props();
</script>

<!-- Single meta chip: uppercase, muted by default, tone-aware. Shared by the
     departures source chip strip and the route/departures freshness chip. -->
<span class="chip" class:chip-accent={tone === 'accent'} class:chip-warn={tone === 'warn'}>
  {@render children()}
</span>

<style>
  .chip {
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    color: var(--color-fg-muted);
    padding: 1px 8px;
    border-radius: 3px;
    font-size: var(--font-size-xs);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .chip-accent {
    color: var(--color-primary);
  }

  .chip-warn {
    color: var(--color-warn);
    border-color: var(--color-warn);
  }
</style>
